module.exports = __webpack_public_path__ + "img/假期管理1.5e48bdc1.svg";